{
  "error500": {
    "title": "500 Greška na serveru",
    "subtitle": "Nešto je pošlo po zlu sa naše strane",
    "description": "Izvinjavamo se na neprijatnosti. Došlo je do interne greške na serveru i nismo mogli da obradimo vaš zahtev. Naš tim je obavešten.",
    "tryAgain": "Pokušaj ponovo",
    "goHome": "Idi na početnu",
    "errorCode": "Kod greške"
  },
  "sidebar": {
    "title": "Bočna Traka",
    "mobileDescription": "Prikazuje mobilnu bočnu traku.",
    "toggle": "Preklopi Bočnu Traku"
  },
  "nav": {
    "employeeHub": "Hub za zaposlene",
    "timeOff": "Odsustva",
    "orgChart": "Org šema",
    "onboarding": "Onboarding",
    "dashboard": "Početna",
    "counters": "Brojači",
    "users": "Korisnici",
    "activityHistory": "Aktivnost",
    "profile": "Profil",
    "settings": "Podešavanja",
    "collapse": "Skupi",
    "logout": "Odjava",
    "myWork": "Radni prostor",
    "pipeline": "Kampanje",
    "calendar": "Kalendar",
    "clients": "Klijenti",
    "structure": "Struktura",
    "team": "Tim",
    "hr": "HR"
  },
  "theme": {
    "light": "Svetlo",
    "dark": "Tamno",
    "system": "Sistem"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "Korisnik",
    "cancel": "Otkaži",
    "save": "Sačuvaj",
    "dismiss": "Zatvori"
  },
  "login": {
    "title": "Dobrodošli nazad",
    "description": "Unesite vaše podatke za prijavu na vaš nalog",
    "identifier": {
      "username": "Korisničko ime",
      "email": "Email",
      "both": "Korisničko ime ili email",
      "placeholder": "Unesite {{field}}"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "button": "Prijavi se",
    "button.loading": "Prijavljivanje...",
    "error": {
      "identifierRequired": "{{field}} je obavezno polje",
      "passwordLength": "Lozinka mora imati najmanje 6 karaktera",
      "failed": "Prijava nije uspela",
      "unknown": "Došlo je do neočekivane greške"
    },
    "forgotPassword": "Zaboravili ste lozinku?",
    "descriptionEmail": "Prijavite se poslovnim emailom",
    "descriptionPassword": "Unesite lozinku da nastavite",
    "emailPlaceholder": "Unesite email",
    "change": "Promeni",
    "continue": "Nastavi",
    "or": "ili",
    "google": "Nastavi preko Google-a",
    "googleSoon": "Prijava preko Google-a još nije podešena. Za sada koristite email.",
    "noAccount": "Nemate nalog?",
    "signUp": "Registrujte se"
  },
  "invitation": {
    "title": "Završite Vašu Registraciju",
    "description": "Postavite vašu lozinku da aktivirate vaš nalog",
    "username": "Korisničko ime",
    "password": "Lozinka",
    "passwordPlaceholder": "Unesite vašu lozinku",
    "confirmPassword": "Potvrdite Lozinku",
    "confirmPasswordPlaceholder": "Potvrdite vašu lozinku",
    "button": "Postavi Lozinku i Aktiviraj",
    "button.loading": "Postavljanje...",
    "invalidTitle": "Nevažeća Pozivnica",
    "goToLogin": "Idi na Prijavu",
    "resetPassword": {
      "title": "Resetuj Vašu Lozinku",
      "description": "Unesite novu lozinku za vaš nalog",
      "button": "Resetuj Lozinku",
      "button.loading": "Resetovanje..."
    },
    "error": {
      "noToken": "Token za pozivnicu nije prosleđen",
      "invalidToken": "Nevažeći ili istekao token za pozivnicu",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "failed": "Neuspešno postavljanje lozinke. Molimo pokušajte ponovo."
    }
  },
  "profile": {
    "title": "Moj Nalog",
    "subtitle": "Upravljajte profilom i bezbednosnim podešavanjima",
    "edit": "Izmeni",
    "verified": "Verifikovan",
    "updateSuccess": "Profil uspešno ažuriran",
    "updateError": "Greška pri ažuriranju profila",
    "info": {
      "title": "Informacije o Profilu",
      "description": "Detalji vašeg naloga"
    },
    "field": {
      "name": "Puno Ime",
      "username": "Korisničko Ime",
      "email": "Email",
      "memberSince": "Član Od"
    },
    "editModal": {
      "title": "Izmeni Profil",
      "description": "Ažurirajte informacije vašeg profila"
    },
    "security": {
      "title": "Promeni Lozinku",
      "description": "Ažurirajte lozinku da biste zaštitili vaš nalog",
      "currentPassword": "Trenutna Lozinka",
      "newPassword": "Nova Lozinka",
      "confirmPassword": "Potvrdite Novu Lozinku",
      "passwordMismatch": "Lozinke se ne poklapaju",
      "passwordInvalid": "Lozinka ne ispunjava zahteve",
      "changeSuccess": "Lozinka uspešno promenjena. Ostale sesije su zatvorene.",
      "changeError": "Greška pri promeni lozinke",
      "changeButton": "Promeni Lozinku"
    },
    "sessions": {
      "currentSession": "Trenutna Sesija",
      "current": "Trenutna",
      "device": "Uređaj",
      "ip": "IP Adresa",
      "lastActive": "Poslednja Aktivnost",
      "now": "Sada",
      "unknown": "Nepoznato",
      "otherSessions": "Ostale Sesije",
      "otherDescription": "Sesije aktivne na drugim uređajima",
      "revokeAll": "Opozovi Sve",
      "revoke": "Opozovi",
      "revokeSuccess": "Sesija uspešno opozvana",
      "revokeError": "Greška pri opozivanju sesije",
      "revokeAllSuccess": "Sve ostale sesije su zatvorene",
      "revokeAllError": "Greška pri opozivanju sesija",
      "noOtherSessions": "Nema drugih aktivnih sesija",
      "lastActiveAt": "Poslednja aktivnost {{time}}",
      "neverActive": "Nikada aktivna",
      "confirmRevokeAll": {
        "title": "Opozovi Sve Sesije",
        "description": "Ovo će zatvoriti sve ostale sesije. Ostaćete prijavljeni na ovom uređaju."
      },
      "time": {
        "daysAgo": "pre {{count}} d",
        "hoursAgo": "pre {{count}} h",
        "justNow": "upravo sada",
        "minutesAgo": "pre {{count}} min"
      },
      "unknownBrowser": "Nepoznat pregledač",
      "unknownDevice": "Nepoznat uređaj"
    }
  },
  "settings": {
    "title": "Podešavanja",
    "subtitle": "Upravljajte preferencama vaše aplikacije",
    "theme": "Tema",
    "themeDescription": "Izaberite vašu željenu temu",
    "language": "Jezik",
    "languageDescription": "Izaberite vaš željeni jezik"
  },
  "users": {
    "title": "Korisnici",
    "button": {
      "add": "Dodaj Korisnika",
      "resetPassword": "Resetuj Lozinku",
      "resendInvitation": "Pošalji Pozivnicu Ponovo",
      "deactivate": "Deaktiviraj",
      "activate": "Aktiviraj",
      "demoteFromAdmin": "Ukloni ulogu administratora",
      "promoteToAdmin": "Unapredi u administratora",
      "delete": "Obriši"
    },
    "table": {
      "username": "Korisničko ime",
      "email": "Email",
      "name": "Ime",
      "role": "Uloga",
      "status": "Status",
      "lastLogin": "Poslednja Prijava",
      "created": "Kreiran",
      "actions": "Akcije",
      "noResults": "Nema pronađenih korisnika",
      "roles": "Uloge"
    },
    "status": {
      "active": "Aktivan",
      "inactive": "Neaktivan"
    },
    "date": {
      "never": "Nikad"
    },
    "actions": {
      "label": "Akcije",
      "copyId": "Kopiraj ID korisnika",
      "editUser": "Izmeni korisnika",
      "openMenu": "Otvori meni",
      "viewDetails": "Prikaži detalje"
    },
    "filter": {
      "allRoles": "Sve Uloge",
      "allStatus": "Svi Statusi"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu..."
    },
    "error": {
      "create": "Neuspešno kreiranje korisnika",
      "delete": "Neuspešno brisanje korisnika",
      "resetPassword": "Neuspešno resetovanje lozinke",
      "resendInvitation": "Neuspešno slanje pozivnice",
      "activate": "Neuspešno aktiviranje korisnika",
      "demote": "Uklanjanje uloge korisniku nije uspelo",
      "promote": "Unapređenje korisnika nije uspelo",
      "deactivate": "Neuspešno deaktiviranje korisnika"
    },
    "role": {
      "USER": "Korisnik",
      "ADMIN": "Administrator",
      "SUPERADMIN": "Super Administrator"
    },
    "modal": {
      "add": {
        "title": "Dodaj Novog Korisnika",
        "description": "Kreirajte novi korisnički nalog. Biće generisan link za pozivnicu.",
        "name": "Ime",
        "namePlaceholder": "Unesite puno ime...",
        "email": "Email",
        "emailPlaceholder": "Unesite email...",
        "emailOptional": "Email (opciono)",
        "identifierHint": "Unesite korisničko ime, email ili oboje — korisnik se prijavljuje onim što postavite.",
        "username": "Korisničko ime",
        "usernamePlaceholder": "Unesite korisničko ime...",
        "role": "Uloga",
        "password": "Lozinka (opciono)",
        "passwordPlaceholder": "Ostavite prazno za slanje linka za pozivnicu",
        "passwordHint": "Ako se ostavi prazno, biće generisan link za pozivnicu kako bi korisnik postavio svoju lozinku.",
        "button": "Kreiraj Korisnika",
        "rolePlaceholder": "Izaberite ulogu"
      },
      "invitation": {
        "copied": "Link je kopiran",
        "copyFailed": "Kopiranje nije uspjelo. Kopirajte link ručno.",
        "title": "Link za Pozivnicu",
        "message": "Podelite ovaj link sa korisnikom da završi svoju registraciju.",
        "emailSent": "Pozivnica je poslata na {{email}}.",
        "emailFailed": "Pozivnica nije mogla biti poslata na {{email}}. Pošaljite link ispod ručno.",
        "button": {
          "copy": "Kopiraj Link",
          "done": "Gotovo"
        }
      },
      "deactivate": {
        "title": "Deaktiviraj Korisnika",
        "message": "Da li ste sigurni da želite da deaktivirate {{username}}?",
        "button": "Deaktiviraj"
      },
      "selfReset": {
        "title": "Resetuj Vašu Lozinku",
        "message": "Upravo ćete resetovati svoju lozinku. Bićete odjavljeni i moraćete koristiti link za pozivnicu da se ponovo prijavite.",
        "button": "Resetuj Lozinku"
      },
      "button": {
        "cancel": "Otkaži"
      },
      "delete": {
        "title": "Obriši Korisnika",
        "message": "Ovo trajno briše {{username}} i ne može se poništiti. Nalog se odjavljuje svuda i više nikada ne može da se prijavi, a njegovo korisničko ime i email postaju slobodni za nekog drugog. Da samo uklonite pristup, deaktivirajte ga.",
        "confirm": "Upišite {{username}} da potvrdite",
        "button": "Obriši Korisnika"
      }
    },
    "card": {
      "total": "ukupno"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "counters": {
    "title": "Brojači",
    "description": "Upravljajte vašim brojačima",
    "newCounter": "Novi Brojač",
    "empty": "Još nema brojača. Kreirajte jedan da počnete!",
    "lastUpdated": "Poslednje ažurirano:",
    "modal": {
      "title": "Kreiraj Novi Brojač",
      "description": "Unesite ime za vaš novi brojač.",
      "nameLabel": "Ime Brojača",
      "namePlaceholder": "Unesite ime brojača...",
      "cancel": "Otkaži",
      "create": "Kreiraj"
    },
    "clearAll": "Obriši sve",
    "clearAllModal": {
      "cancel": "Otkaži",
      "confirm": "Obriši sve",
      "description": "Da li ste sigurni da želite da obrišete svih {{count}} brojača? Ova radnja se ne može poništiti.",
      "title": "Obriši sve brojače"
    },
    "error": {
      "create": "Kreiranje brojača nije uspelo",
      "decrement": "Umanjenje brojača nije uspelo",
      "delete": "Brisanje brojača nije uspelo",
      "deleteAll": "Brisanje svih brojača nije uspelo",
      "increment": "Uvećanje brojača nije uspelo",
      "reset": "Resetovanje brojača nije uspelo"
    },
    "loadError": "Brojači nisu mogli da se učitaju.",
    "noResults": "Nijedan brojač ne odgovara vašoj pretrazi.",
    "search": "Pretraži brojače...",
    "toast": {
      "incremented": "Brojač je uvećan"
    },
    "total": "ukupno"
  },
  "activity": {
    "table": {
      "timestamp": "Vreme",
      "action": "Akcija",
      "entityType": "Tip Entiteta",
      "user": "Korisnik",
      "ip": "IP Adresa",
      "status": "Status",
      "noResults": "Nema pronađenih zapisa aktivnosti"
    },
    "status": {
      "success": "Uspešno",
      "failed": "Neuspešno"
    },
    "filter": {
      "clear": "Obriši",
      "allActions": "Sve Akcije",
      "allEntities": "Svi Tipovi Entiteta",
      "allStatus": "Svi Statusi"
    },
    "entityType": {
      "session": "Sesija",
      "user": "Korisnik",
      "counter": "Brojač"
    },
    "action": {
      "LOGIN": "Prijava",
      "LOGIN_FAILED": "Neuspešna Prijava",
      "LOGOUT": "Odjava",
      "LOGOUT_ALL": "Odjava Svih",
      "TOKEN_REFRESH": "Obnova Tokena",
      "CREATE": "Kreiranje",
      "UPDATE": "Ažuriranje",
      "DELETE": "Brisanje",
      "PASSWORD_SET": "Postavljanje Lozinke",
      "PASSWORD_CHANGE": "Promena Lozinke",
      "PASSWORD_RESET": "Resetovanje Lozinke",
      "REGISTER": "Registracija",
      "EMAIL_VERIFY": "Verifikacija Emaila",
      "RESEND_VERIFICATION": "Ponovno Slanje Verifikacije"
    },
    "search": {
      "placeholder": "Pretraži po korisničkom imenu, IP, entitetu..."
    },
    "button": {
      "details": "Detalji"
    },
    "modal": {
      "title": "Detalji Aktivnosti"
    },
    "details": {
      "error": "Greška",
      "previousState": "Prethodno Stanje",
      "newState": "Novo Stanje",
      "metadata": "Metapodaci",
      "userAgent": "User Agent"
    },
    "pagination": {
      "of": "od",
      "page": "Strana",
      "rowsPerPage": "Redova po strani"
    }
  },
  "activityHistory": {
    "title": "Istorija Aktivnosti",
    "description": "Pregledajte sistemske revizijske logove i aktivnost korisnika",
    "card": {
      "total": "unosa"
    }
  },
  "toast": {
    "sessionExpired": "Sesija je istekla. Molimo prijavite se ponovo.",
    "deviceMismatch": "Ova sesija pripada drugom uređaju. Molimo prijavite se ponovo.",
    "rateLimited": "Previše zahteva. Molimo pokušajte ponovo kasnije.",
    "reconnecting": "Ponovno povezivanje…",
    "unreachable": "Nismo mogli da pristupimo serveru — možda se ponovo pokreće. Ništa nije sačuvano; pokušajte ponovo za trenutak."
  },
  "backend": {
    "accountLocked": "Previše neuspešnih pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "accountLockedTitle": "Nalog je privremeno zaključan",
    "badRequest": "Zahtev nije ispravan",
    "cannotAssignCustomerRole": "Uloga korisnika-kupca ne može da se dodeli nalozima kojima upravljaju administratori",
    "cannotDeactivateOwnAccount": "Ne možete deaktivirati sopstveni nalog",
    "cannotDeleteOwnAccount": "Ne možete obrisati sopstveni nalog",
    "cannotDeleteSuperAdmin": "Super administratori ne mogu da se obrišu",
    "cannotModifyOwnRoles": "Ne možete menjati sopstvene uloge",
    "cannotModifyOwnSuperAdmin": "Ne možete menjati sopstveni status super administratora",
    "cannotResendSuperAdminInvitation": "Pozivnice ne mogu ponovo da se šalju super administratorima",
    "cannotResetSuperAdminPassword": "Lozinka super administratora ne može ovde da se resetuje",
    "cannotUpdateSuperAdmin": "Super administratori ne mogu da se menjaju",
    "conflict": "Ovo već postoji",
    "counterNotFound": "Brojač nije pronađen",
    "currentPasswordIncorrect": "Trenutna lozinka nije tačna",
    "emailAlreadyVerified": "Ovaj email je već potvrđen. Možete se prijaviti.",
    "emailExists": "Ovaj email je već registrovan",
    "emailNotVerified": "Potvrdite vaš email pre prijave",
    "emailRequired": "Email je obavezan",
    "fetchActivityFailed": "Aktivnost nije mogla da se učita",
    "fetchProfileFailed": "Profil nije mogao da se učita",
    "fetchSessionsFailed": "Sesije nisu mogle da se učitaju",
    "fetchUsersFailed": "Korisnici nisu mogli da se učitaju",
    "forbidden": "Nemate dozvolu za to",
    "identifierInUse": "To korisničko ime ili email je već u upotrebi",
    "identifierRequired": "Korisničko ime ili email je obavezan",
    "invalidCredentials": "Pogrešno korisničko ime ili lozinka",
    "invalidEmail": "Neispravan format email adrese",
    "invalidInvitationToken": "Nevažeći ili istekao link pozivnice",
    "invalidResetToken": "Ovaj link za resetovanje lozinke nije važeći ili je istekao",
    "invalidVerificationToken": "Ovaj link za potvrdu nije važeći ili je istekao",
    "logoutAllFailed": "Odjava ostalih sesija nije uspela",
    "logoutFailed": "Odjava nije uspela",
    "newPasswordSameAsCurrent": "Nova lozinka mora da se razlikuje od trenutne",
    "noPlatformAccess": "Vaš nalog nema pristup ovoj aplikaciji",
    "notFound": "Nije pronađeno",
    "onlySuperAdminsCreateSuperAdmins": "Samo super administratori mogu da kreiraju super administratore",
    "onlySuperAdminsManageSuperAdmins": "Samo super administratori mogu da upravljaju statusom super administratora",
    "passwordAlreadySet": "Ovaj korisnik je već postavio lozinku. Umesto toga koristite resetovanje lozinke.",
    "passwordComplexity": "Lozinka ne ispunjava zahteve",
    "passwordMinLength": "Lozinka mora imati najmanje {{count}} karaktera",
    "passwordNotSet": "Ovaj nalog nema postavljenu lozinku",
    "passwordSetupRequired": "Morate postaviti lozinku pre prijave",
    "profileNotFound": "Profil nije pronađen",
    "registrationFailed": "Registracija nije uspela",
    "registrationUnavailable": "Registracija nije dostupna",
    "resetPasswordFailed": "Resetovanje lozinke nije uspelo",
    "revokeSessionFailed": "Opoziv sesije nije uspeo",
    "securityCheckFailed": "Bezbednosna provera nije uspela. Osvežite stranicu i pokušajte ponovo.",
    "serverError": "Došlo je do greške na našoj strani. Pokušajte ponovo.",
    "sessionNotFound": "Sesija nije pronađena",
    "tooManyLoginAttempts": "Previše pokušaja prijave. Pokušajte ponovo za {{seconds}} sekundi",
    "updateUserFailed": "Ažuriranje korisnika nije uspelo",
    "userNotFound": "Korisnik nije pronađen",
    "usernameDerivedFromEmail": "Korisničko ime se izvodi iz emaila kada je prijava putem emaila",
    "usernameExists": "Korisničko ime već postoji",
    "usernameRequired": "Korisničko ime je obavezno",
    "verificationFailed": "Potvrda nije uspela",
    "verificationUnavailable": "Potvrda emaila nije dostupna",
    "verifyInvitationFailed": "Pozivnica nije mogla da se proveri",
    "accountDeactivated": "Nalog je deaktiviran",
    "accountLockedFor": "Nalog je zaključan na {{seconds}} sekundi",
    "invalidPassword": "Pogrešna lozinka",
    "invalidPasswordLocked": "Pogrešna lozinka – nalog je zaključan na {{seconds}} sekundi",
    "passwordPolicyDefault": "Lozinka mora da sadrži veliko slovo, malo slovo, broj i specijalni znak",
    "platformAccessDenied": "Pristup odbijen za ovu platformu ({{platform}})",
    "sendVerificationFailed": "Email za potvrdu nije mogao da se pošalje"
  },
  "dataTable": {
    "clearFilters": "Očisti filtere",
    "columns": "Kolone",
    "noResults": "Nema rezultata.",
    "pagination": {
      "next": "Sledeća",
      "pageOf": "Strana {{page}} od {{pageCount}}",
      "perPage": "{{count}} / strana",
      "previous": "Prethodna",
      "showing": "Prikazano {{from}}–{{to}} od {{total}} rezultata"
    },
    "rowsSelected": "Izabrano {{selected}} od {{total}} redova.",
    "searchPlaceholder": "Pretraži...",
    "column": {
      "actions": "Radnje",
      "createdAt": "Kreirano",
      "isActive": "Status",
      "lastLoginAt": "Poslednja prijava",
      "name": "Ime",
      "roles": "Uloge",
      "username": "Korisničko ime"
    }
  },
  "forgotPassword": {
    "backToLogin": "Nazad na prijavu",
    "description": "Unesite vaš email i poslaćemo vam link za resetovanje.",
    "email": "Email",
    "emailPlaceholder": "Unesite vaš email",
    "sent": {
      "description": "Ako nalog sa ovim emailom postoji, dobićete link za resetovanje lozinke.",
      "title": "Proverite vaš email"
    },
    "submit": "Pošalji link za resetovanje",
    "title": "Zaboravljena lozinka"
  },
  "password": {
    "error": {
      "complexity": "Lozinka ne ispunjava zahteve",
      "minLength": "Lozinka mora imati najmanje {{count}} karaktera"
    },
    "requirement": {
      "complexity": "Ispunjava zahteve složenosti",
      "minLength": "Najmanje {{count}} karaktera"
    },
    "show": "Prikaži lozinku",
    "hide": "Sakrij lozinku"
  },
  "register": {
    "button": "Napravi nalog",
    "button.loading": "Kreiranje naloga...",
    "confirmPassword": {
      "label": "Potvrdite lozinku",
      "placeholder": "Potvrdite vašu lozinku"
    },
    "description": "Unesite svoje podatke da biste napravili nalog",
    "email": {
      "label": "Email",
      "placeholder": "Unesite vaš email"
    },
    "error": {
      "failed": "Registracija nije uspela. Pokušajte ponovo.",
      "invalidEmail": "Unesite ispravnu email adresu",
      "nameRequired": "Ime je obavezno",
      "passwordLength": "Lozinka mora imati najmanje 8 karaktera",
      "passwordMismatch": "Lozinke se ne poklapaju"
    },
    "hasAccount": "Već imate nalog?",
    "name": {
      "label": "Ime",
      "placeholder": "Unesite vaše ime"
    },
    "password": {
      "label": "Lozinka",
      "placeholder": "Unesite vašu lozinku"
    },
    "signIn": "Prijavite se",
    "success": "Registracija je uspela! Proverite vaš email da biste potvrdili nalog.",
    "title": "Napravite nalog"
  },
  "resetPassword": {
    "confirmPassword": "Potvrdite lozinku",
    "description": "Unesite vašu novu lozinku ispod.",
    "error": "Resetovanje lozinke nije uspelo",
    "goToLogin": "Idi na prijavu",
    "invalid": {
      "description": "Ovaj link za resetovanje lozinke je istekao ili nije važeći. Zatražite novi.",
      "title": "Nevažeći ili istekao link"
    },
    "newPassword": "Nova lozinka",
    "passwordInvalid": "Lozinka ne ispunjava zahteve",
    "passwordMismatch": "Lozinke se ne poklapaju",
    "requestNew": "Zatraži novi link",
    "submit": "Resetuj lozinku",
    "success": "Lozinka je uspešno resetovana",
    "success.description": "Uskoro ćete biti preusmereni na prijavu.",
    "success.title": "Lozinka je resetovana",
    "title": "Resetovanje lozinke"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "Ovaj link za potvrdu nije važeći ili je istekao.",
      "noToken": "Nije prosleđen token za potvrdu",
      "title": "Potvrda nije uspela"
    },
    "goToLogin": "Idi na prijavu",
    "needAccount": "Nemate nalog?",
    "resend": {
      "button": "Ponovo pošalji email za potvrdu",
      "cancel": "Otkaži",
      "email": {
        "label": "Email adresa",
        "placeholder": "Unesite vaš email"
      },
      "emailRequired": "Unesite vaš email",
      "sending": "Slanje...",
      "submit": "Pošalji",
      "success": "Ako je vaš email registrovan, dobićete email za potvrdu."
    },
    "signUp": "Registrujte se",
    "success": {
      "description": "Vaš email je uspešno potvrđen. Sada se možete prijaviti na svoj nalog.",
      "redirect": "Preusmeravanje na prijavu...",
      "title": "Email je potvrđen!"
    }
  },
  "unsavedChanges": {
    "title": "Izađi bez čuvanja?",
    "body": "Tvoje izmene će biti izgubljene.",
    "stay": "Ostani",
    "leave": "Izađi"
  },
  "richText": {
    "bold": "Podebljano",
    "italic": "Kurziv",
    "underline": "Podvučeno",
    "strike": "Precrtano",
    "heading": "Naslov",
    "paragraph": "Pasus",
    "bullets": "Lista sa tačkama",
    "numbers": "Numerisana lista",
    "quote": "Citat"
  },
  "oktober": {
    "search": {
      "handbook": "Hub za zaposlene",
      "title": "Pronađi bilo šta",
      "placeholder": "Pretraži zadatke, klijente, ljude i stranice…",
      "pages": "Stranice",
      "clients": "Klijenti",
      "myClients": "Moji klijenti",
      "tasks": "Zadaci",
      "people": "Ljudi",
      "empty": "Ništa ne odgovara „{{query}}“",
      "move": "za kretanje",
      "open": "za otvaranje",
      "close": "za zatvaranje"
    },
    "sidebar": {
      "peopleOut": "{{count}} · {{out}} odsutno",
      "daysLeft": "još {{count}} d.",
      "findAnything": "Pronađi bilo šta",
      "company": "Kompanija",
      "system": "Sistem",
      "pod": "Pod {{name}}",
      "noPod": "Bez poda",
      "noTeam": "Bez tima",
      "otherTeams": "Ostalo",
      "collapse": "Skupi meni",
      "expand": "Proširi meni",
      "home": "October OS početna",
      "searchShortcut": "Pretraga (Ctrl K)",
      "search": "Pretraga",
      "findClient": "Pronađi klijenta",
      "results": "Rezultati",
      "clients": "Klijenti",
      "mine": "Moji",
      "all": "Svi",
      "noMatch": "Nijedan klijent ne odgovara „{{query}}“",
      "health": "Zdravlje {{value}}/5"
    },
    "userMenu": {
      "language": "Jezik"
    },
    "viewingAs": {
      "label": "Prikaz kao",
      "hint": "Vaša prijava još nije povezana ni sa kim iz tima, pa vidite tuđi posao."
    },
    "splash": {
      "tagline": "Brend sistemi za Figma plugin.",
      "hint": "v0.4 — lokalna verzija · kliknite za nastavak"
    },
    "auth": {
      "copyright": "© {{year}} Oktober. Sva prava zadržana."
    },
    "loading": "Učitavanje…",
    "notAvailable": "Nije dostupno dok se ne poveže backend.",
    "actionFailed": "Nešto nije u redu.",
    "errors": {
      "teamMissing": "Taj tim više ne postoji.",
      "podMissing": "Taj pod više ne postoji.",
      "taskNotFound": "Zadatak nije pronađen.",
      "titleRequired": "Naslov je obavezan.",
      "commentEmpty": "Prvo napišite komentar.",
      "employeeNotFound": "Osoba nije pronađena.",
      "emailTaken": "Neko već koristi ovaj email.",
      "selfManager": "Osoba ne može biti sama sebi nadređena.",
      "nameEmailRequired": "Ime i email su obavezni.",
      "clientNotFound": "Klijent nije pronađen.",
      "nameRequired": "Ime klijenta je obavezno.",
      "leaveDates": "Datum završetka je pre datuma početka.",
      "leaveNotFound": "Zahtev za odsustvo nije pronađen.",
      "templateNotFound": "Šablon nije pronađen.",
      "checklistItemNotFound": "Stavka liste nije pronađena."
    }
  },
  "vocab": {
    "stage": { "BACKLOG": "Na čekanju", "BRIEFING": "Brifing", "COPYWRITING": "Pisanje teksta", "DESIGN": "Dizajn", "INTERNAL_REVIEW": "Interna provera", "CLIENT_REVIEW": "Provera klijenta", "IMPLEMENTATION": "Implementacija", "QA_SCHEDULE": "QA i zakazivanje", "SCHEDULED": "Zakazano", "SENT": "Poslato" },
    "assetType": { "EMAIL_CAMPAIGN": "Email kampanja", "EMAIL_FLOW": "Email tok", "SMS_CAMPAIGN": "SMS kampanja", "ACCOUNT_MANAGEMENT": "Upravljanje nalogom", "LIST_GROWTH": "Rast liste", "AD_CREATIVE": "Oglasni kreativ", "DESIGN_ONLY": "Samo dizajn", "AB_TEST": "A/B test", "OTHER": "Ostalo" },
    "assetTypeShort": { "EMAIL_CAMPAIGN": "Kampanja", "EMAIL_FLOW": "Tok", "SMS_CAMPAIGN": "SMS", "ACCOUNT_MANAGEMENT": "AM", "LIST_GROWTH": "Rast liste", "AD_CREATIVE": "Oglas", "DESIGN_ONLY": "Samo dizajn", "AB_TEST": "A/B", "OTHER": "Ostalo" },
    "pillar": { "PRODUCT": "Proizvod", "CONTENT": "Sadržaj", "LOYALTY": "Lojalnost", "PROMOTION": "Promocija", "DATA": "Podaci", "WINBACK": "Povratak kupaca" },
    "priority": { "URGENT": "Hitno", "HIGH": "Visok", "NORMAL": "Normalan", "LOW": "Nizak" },
    "taskRole": { "accountManager": "Menadžer naloga", "copywriter": "Kopirajter", "designer": "Dizajner", "implementor": "Implementator" },
    "taskRoleShort": { "accountManager": "AM", "copywriter": "Tekst", "designer": "Dizajn", "implementor": "Impl" },
    "employeeRole": { "LEADERSHIP": "Rukovodstvo", "TEAM_LEAD": "Vođa tima", "RETENTION_MANAGER": "Menadžer retencije", "DESIGNER": "Dizajner", "KLAVIYO_TECH": "Klaviyo tehničar", "OPS": "Operacije", "OTHER": "Ostalo" },
    "employeeStatus": { "ONBOARDING": "Uvođenje", "ACTIVE": "Aktivan", "OFFBOARDED": "Otišao" },
    "clientStatus": { "ONBOARDING": "Uvođenje", "ACTIVE": "Aktivan", "OFFBOARDING": "Odlazi", "INACTIVE": "Neaktivan" },
    "leaveType": { "VACATION": "Godišnji odmor", "SICK": "Bolovanje", "OTHER": "Ostalo" },
    "leaveStatus": { "PENDING": "Na čekanju", "APPROVED": "Odobreno", "REJECTED": "Odbijeno" },
    "onboardingTarget": { "EMPLOYEE": "Zaposleni", "CLIENT": "Klijent" },
    "assetKind": { "LOGO": "Logo", "FONT": "Font", "IMAGE": "Slika" }
  },
  "pipeline": {
    "eyebrow": "Pipeline kampanja",
    "title": "Kampanje",
    "viewBoard": "Tabla",
    "viewList": "Lista",
    "viewCalendar": "Kalendar",
    "newTaskPlaceholder": "Naslov novog zadatka…",
    "clientPlaceholder": "Klijent…",
    "add": "Dodaj",
    "searchPlaceholder": "Pretraži zadatke ili klijente",
    "myWork": "Moj posao",
    "mineTitle": "Zadaci na kojima imate bilo koju ulogu",
    "mineUnlinked": "Vaša prijava još nije povezana sa članom tima",
    "allTeams": "Svi timovi",
    "allPods": "Svi podovi",
    "allClients": "Svi klijenti",
    "anyone": "Bilo ko",
    "allTypes": "Svi tipovi",
    "clear": "Poništi",
    "loading": "Učitavanje…",
    "taskCount_one": "{{count}} zadatak",
    "taskCount_few": "{{count}} zadatka",
    "taskCount_other": "{{count}} zadataka",
    "emailsCount_one": "{{count}} imejl",
    "emailsCount_few": "{{count}} imejla",
    "emailsCount_other": "{{count}} imejlova",
    "totalEmailsTitle": "Ukupno imejlova u ovoj koloni",
    "showAll": "Prikaži svih {{count}}",
    "blocked": "Blokirano",
    "waitingOnClient": "Čeka se klijent",
    "sendDate": "Datum slanja",
    "noSendDate": "Bez datuma slanja",
    "colSend": "Slanje",
    "colClient": "Klijent",
    "colTask": "Zadatak",
    "colType": "Tip",
    "colStage": "Faza",
    "colPeople": "Ljudi",
    "workTabs": "Moji zadaci",
    "tabNow": "Sada",
    "tabUpcoming": "Uskoro",
    "tabFinished": "Završeno",
    "colName": "Naziv",
    "colMyDeadline": "Moj rok",
    "colRoleDeadline": "Rok: {{role}}",
    "viewLabel": "Prikaz",
    "colStageDeadline": "Rok faze",
    "comments": "Komentari",
    "noMatch": "Nijedan zadatak ne odgovara ovim filterima."
  },
  "calendar": {
    "eyebrow": "Kalendar slanja",
    "title": "Kalendar",
    "previousMonth": "Prethodni mesec",
    "nextMonth": "Sledeći mesec",
    "today": "Danas",
    "internal": "Interno",
    "unscheduled_one": "{{count}} zadatak bez datuma slanja (vidi Listu)",
    "unscheduled_few": "{{count}} zadatka bez datuma slanja (vidi Listu)",
    "unscheduled_other": "{{count}} zadataka bez datuma slanja (vidi Listu)",
    "more": "+{{count}} više",
    "less": "Prikaži manje"
  },
  "myWork": {
    "eyebrow": "Vaši zadaci",
    "title": "Radni prostor",
    "noPerson": "Još nema podataka o timu za prikaz.",
    "morning": "Dobro jutro, {{name}}",
    "afternoon": "Dobar dan, {{name}}",
    "evening": "Dobro veče, {{name}}",
    "onDesk": "Trenutno na tvom stolu: {{n}}"
  },
  "task": {
    "viewers": {
      "onlyYou": "Samo si ti ovde",
      "withYou": "Ti i {{names}} ste ovde"
    },
    "stageView": {
      "copy": {
        "subject": "Subject line od najviše 50 karaktera",
        "preview": "Preview tekst napisan",
        "cta": "Jasan CTA",
        "proofread": "Lektorisano: pravopis, ton, glas brenda",
        "tags": "Personalizacioni tagovi provereni",
        "doc": "Finalni tekst je u master dokumentu",
        "title": "Napišite tekst",
        "import": "Krenite od master dokumenta",
        "subjectLabel": "Subject line",
        "previewLabel": "Preview tekst",
        "senderLabel": "Ime pošiljaoca",
        "sectionName": "Naziv sekcije",
        "up": "Pomeri gore",
        "down": "Pomeri dole",
        "remove": "Ukloni sekciju",
        "sectionPh": "H1: …\nTekst: …\nCTA: …",
        "addSection": "Dodajte sekciju",
        "masterDoc": "Master dokument"
      },
      "briefing": {
        "messageLabel": "Ključna poruka i ponuda",
        "openClient": "Otvori klijenta i brand kit",
        "objective": "Cilj napisan",
        "audience": "Publika definisana",
        "message": "Ključna poruka i ponuda",
        "doc": "Copy dokument napravljen i povezan",
        "shared": "Brif prođen sa copywriterom",
        "title": "Napišite brif",
        "hint": "Sve što copywriteru treba da krene bez pitanja.",
        "audiencePh": "Segmenti koje uključujemo i isključujemo",
        "messagePh": "Jedina stvar koju čitalac treba da zapamti, i ponuda ako postoji",
        "docTitle": "Copy dokument",
        "docHint": "Povežite naslov mejla u master dokumentu, da svako stigne pravo na njega.",
        "noNotes": "Još nema beleški o klijentu."
      },
      "notSet": "Nije popunjeno",
      "design": {
        "copyTitle": "Tekst za dizajn",
        "noCopy": "Još nema teksta: pojaviće se ovde kad ga copywriter napiše.",
        "figma": "Figma frejm povezan",
        "copy": "Koristi poslednju verziju teksta",
        "brand": "Boje, fontovi i komponente brenda",
        "mobile": "Provereno na širini telefona",
        "images": "Slike izvezene i kompresovane",
        "notes": "Linkovi i alt tekstovi zabeleženi za Klaviyo",
        "brandTitle": "Brend",
        "copyTab": "Tekst",
        "designTab": "Dizajn"
      },
      "backlog": {
        "client": "Klijent izabran",
        "send": "Datum slanja postavljen",
        "am": "Account manager dodeljen",
        "copywriter": "Copywriter dodeljen",
        "designer": "Dizajner dodeljen",
        "implementor": "Klaviyo tehničar dodeljen",
        "deadlines": "Interni rokovi postavljeni",
        "deadlinesHint": "Tekst, dizajn i Klaviyo",
        "title": "Isplanirajte ovaj mejl",
        "missing": "Pre brifa treba srediti još {{n}} stvari. Popunite ih u Detaljima i kod ljudi iznad.",
        "ready": "Sve je spremno: može na brif.",
        "objectivePh": "Šta ovaj mejl treba da postigne?"
      },
      "review": {
        "feedbackPh": "Šta treba promeniti? Biće objavljeno kao komentar.",
        "backTo": "Nazad na {{stage}}",
        "brief": "U skladu sa brifom",
        "inbox": "Subject line i preview tekst su dobri",
        "typos": "Bez grešaka, ton odgovara brendu",
        "links": "CTA-ovi i linkovi vode gde treba",
        "design": "Dizajn prati tekst i brend",
        "mobile": "Radi na telefonu",
        "decision": "Odluka",
        "approve": "Odobri: pošalji na {{stage}}",
        "changes": "Ili vratite sa beleškama"
      },
      "client": {
        "msgHello": "Zdravo! Sledeći mejl je spreman za vaš pregled:",
        "msgDesign": "Dizajn",
        "msgCopy": "Tekst",
        "msgThanks": "Javite nam ako želite neke izmene.",
        "title": "Kod klijenta",
        "hint": "Pošaljite klijentu dizajn i tekst, pa ovde zabeležite odgovor.",
        "waiting": "Dana čekanja na klijenta: {{n}}",
        "copyMessage": "Kopiraj poruku za klijenta",
        "answer": "Odgovor klijenta",
        "feedback": "Povratna informacija klijenta",
        "approved": "Klijent odobrio: dalje na {{stage}}",
        "changes": "Tražene izmene"
      },
      "checklist": "Čeklista",
      "autoCheck": "Štiklira se samo kad se ovo popuni",
      "copyText": "Kopiraj",
      "copied": "Kopirano",
      "build": {
        "sheet": "Build sheet",
        "sheetHint": "Sve što se lepi u Klaviyo, iz teksta i detalja.",
        "links": "Linkovi u tekstu",
        "klaviyo": "Klaviyo kampanja",
        "openKlaviyo": "Otvori",
        "klaviyoUrl": "Link kampanje",
        "template": "Template napravljen po Figma frejmu",
        "inbox": "Subject, preview tekst i pošiljalac postavljeni",
        "segments": "Segmenti i isključenja postavljeni",
        "utm": "Linkovi i UTM-ovi provereni",
        "alt": "Alt tekst na svakoj slici",
        "test": "Test mejl poslat timu",
        "campaign": "Kampanja povezana ovde"
      },
      "qa": {
        "inbox": "Test stiže u inbox, ne u spam",
        "desktop": "Izgleda dobro na desktopu",
        "mobile": "Izgleda dobro na telefonu i u dark modu",
        "links": "Svaki link otvara pravu stranicu",
        "tags": "Personalizacija se prikazuje, sa rezervnim vrednostima",
        "footer": "Odjava i futer postoje",
        "time": "Vreme slanja i vremenska zona potvrđeni",
        "scheduled": "Zakazano u Klaviyu",
        "schedule": "Zakazivanje",
        "sendsAt": "Šalje se {{date}}",
        "noDate": "Još nema datuma slanja: postavite ga u Detaljima.",
        "markScheduled": "Označi kao {{stage}}"
      },
      "scheduled": {
        "due": "Vreme slanja je prošlo",
        "inDays": "Šalje se za {{n}} d",
        "inHours": "Šalje se za {{n}} h"
      },
      "sent": {
        "title": "Rezultati",
        "hint": "Iz Klaviya, par dana posle slanja.",
        "open": "Open rate %",
        "click": "Click rate %",
        "revenue": "Prihod",
        "learnings": "Šta zadržati ili promeniti sledeći put"
      },
      "waitingClient": "Čeka se klijent",
      "for": "Radi: {{role}}",
      "due": "Rok {{date}}",
      "modeLabel": "Radni prostor",
      "focus": "Prikaz faze",
      "all": "Sve"
    },
    "back": "Nazad",
    "loading": "Učitavanje…",
    "missing": "Ovaj zadatak više ne postoji.",
    "internal": "Interno",
    "sends": "Šalje se {{date}}",
    "close": "Zatvori zadatak",
    "blocked": "Blokirano",
    "markBlocked": "Označi kao blokirano",
    "moveTo": "Pomeri na: {{stage}}",
    "deleteConfirm": "Obrisati ovaj zadatak?",
    "delete": "Obriši zadatak",
    "openInClickup": "Otvori u ClickUp-u",
    "layout": {
      "page": "Stranica",
      "modal": "Iskačući prozor",
      "drawer": "Bočno",
      "openAs": "Otvaraj zadatke kao",
      "pageTitle": "Otvaraj zadatke kao stranicu",
      "modalTitle": "Otvaraj zadatke kao iskačući prozor",
      "drawerTitle": "Otvaraj zadatke kao bočni panel"
    },
    "people": {
      "nobody": "niko",
      "unassign": "Niko"
    },
    "details": {
      "title": "Detalji",
      "send": "Slanje",
      "client": "Klijent",
      "noPillar": "Bez stuba",
      "type": "Tip",
      "pillar": "Stub",
      "emails": "Mejlovi",
      "priority": "Prioritet"
    },
    "deadlines": {
      "title": "Interni rokovi",
      "copy": "Tekst",
      "design": "Dizajn"
    },
    "brief": {
      "title": "Brif",
      "audience": "Publika",
      "objective": "Cilj",
      "full": "Ceo brif",
      "empty": "prazno",
      "placeholder": "Dodaj detalje…"
    },
    "links": {
      "title": "Linkovi",
      "copyDoc": "Dokument sa tekstom",
      "figmaFrame": "Figma frejm",
      "paste": "Nalepi link…",
      "open": "Otvori {{what}}",
      "edit": "Promeni {{what}}"
    },
    "comments": {
      "title": "Komentari",
      "placeholder": "Napišite komentar…",
      "empty": "Još nema komentara",
      "send": "Pošalji komentar"
    },
    "history": {
      "title": "Istorija",
      "system": "Sistem"
    },
    "timeline": {
      "label": "Faza zadatka",
      "current": "Trenutna faza: {{stage}}",
      "moveTo": "Pomeri na: {{stage}}"
    },
    "activity": {
      "created": "je kreirao/la zadatak",
      "imported": "uvezeno iz ClickUp-a",
      "stage_changed": "je pomerio/la {{from}} → {{to}}",
      "priority_changed": "je postavio/la prioritet na {{priority}}",
      "assigned": "je postavio/la {{role}}: {{person}}",
      "assigned_cleared": "je uklonio/la {{role}}",
      "assignee": "izvršilac",
      "someone": "neko",
      "send_changed": "je postavio/la datum slanja na {{date}}",
      "send_cleared": "je uklonio/la datum slanja",
      "blocked": "je označio/la kao blokirano",
      "unblocked": "je odblokirao/la",
      "commented": "je komentarisao/la",
      "edited": "je izmenio/la zadatak",
      "other": "Ažurirano"
    },
    "copy": {
      "title": "Tekst",
      "sample": "Primer",
      "refresh": "Osveži",
      "refreshUnavailable": "Dostupno kada se poveže Google Docs",
      "openDoc": "Otvori dokument",
      "reading": "Čitanje dokumenta sa tekstom…",
      "noLink": "Tekst još nije povezan. Nalepite Google Docs link do naslova mejla:",
      "hintGuess": "Link ne vodi do naslova, pa je ovaj odeljak pronađen po datumu slanja i naslovu. Proverite da li je to pravi mejl.",
      "hintNone": "Odeljak ovog mejla nije pronađen — prikazan je ceo tab. Povežite zadatak sa naslovom mejla da suzite izbor.",
      "empty": "Ovaj odeljak dokumenta je prazan.",
      "section": "Odeljak",
      "errorTitle": "Tekst nije moguće pročitati",
      "reason": {
        "no-link": "Za ovaj zadatak još nije povezan tekst.",
        "bad-link": "Link do teksta nije Google Docs link.",
        "not-configured": "Google Docs još nije povezan.",
        "api-disabled": "Google Docs API je isključen za ovaj projekat.",
        "no-access": "Nema pristupa ovom Google dokumentu.",
        "heading-missing": "Naslov iz linka nije pronađen u dokumentu.",
        "error": "Došlo je do greške pri čitanju dokumenta."
      }
    },
    "design": {
      "title": "Dizajn",
      "previewAs": "Pregled kao",
      "desktop": "Desktop",
      "mobile": "Mobilni",
      "rerender": "Ponovo renderuj",
      "rerendering": "Renderovanje…",
      "renderedAt": "Renderovano {{date}}",
      "openInFigma": "Otvori u Figmi",
      "noDesign": "Dizajn još ne postoji. Nalepite link do Figma frejma mejla:",
      "iframeTitle": "Figma dizajn",
      "notFigma": "Link dizajna nije Figma link, pa se ne može ugraditi.",
      "rendering": "Renderovanje frejma iz Figme…",
      "errorTitle": "Dizajn nije moguće renderovati",
      "unreachable": "Servis za pregled nije odgovorio. Pokušaj ponovo za trenutak.",
      "notConnected": "Pregled će biti dostupan kada se poveže",
      "searchMail": "Pretraži poštu",
      "inbox": "Prijemno sanduče",
      "toMe": "meni",
      "imageAlt": "{{subject}} — dizajn mejla"
    }
  },
  "dashboard": {
    "hint": {
      "onDesk": "Sada si ti na redu",
      "dueToday": "Tvoj rok je danas",
      "overdueMine": "Prošao ti je rok",
      "upcoming": "Još je kod drugih",
      "waiting": "Na pregledu kod klijenta",
      "sendingToday": "Slanja tvojih klijenata",
      "overdue": "Prošao datum slanja",
      "watch": "Slabo zdravlje, odlazak ili tišina"
    },
    "personal": {
      "intro": "Evo šta je danas na tvom stolu.",
      "clear": "Sto ti je čist — ništa ne čeka na tebe.",
      "noDate": "Bez datuma",
      "kpi": {
        "onDesk": "Na tvom stolu",
        "dueToday": "Rok danas",
        "overdue": "Kasni",
        "upcoming": "Stiže ka tebi",
        "waiting": "Čeka klijenta",
        "sendingToday": "Šalje se danas"
      },
      "desk": {
        "title": "Na tvom stolu",
        "all": "Radni prostor →",
        "empty": "Ništa nije na tvom stolu. Uživaj."
      },
      "upcoming": {
        "title": "Stiže ka tebi",
        "empty": "Još ništa ne stiže ka tebi."
      },
      "clients": {
        "title": "Moji klijenti",
        "empty": "Još nemaš dodeljenih klijenata."
      }
    },
    "there": "tamo",
    "greeting": {
      "morning": "Dobro jutro, {{name}}",
      "afternoon": "Dobar dan, {{name}}",
      "evening": "Dobro veče, {{name}}"
    },
    "intro": {
      "nothingToday": "Danas ne izlazi ništa.",
      "emails_one": "Danas izlazi {{count}} imejl kroz {{sends}}",
      "emails_few": "Danas izlaze {{count}} imejla kroz {{sends}}",
      "emails_other": "Danas izlazi {{count}} imejlova kroz {{sends}}",
      "sends_one": "{{count}} slanje",
      "sends_few": "{{count}} slanja",
      "sends_other": "{{count}} slanja",
      "notReady": " — {{count}} još nije zakazano.",
      "allScheduled": ", sve je zakazano.",
      "nothingOnYou": "Ništa ne čeka tebe.",
      "onYou_one": "{{count}} zadatak čeka tebe.",
      "onYou_few": "{{count}} zadatka čekaju tebe.",
      "onYou_other": "{{count}} zadataka čeka tebe."
    },
    "kpi": {
      "emailsToday": "Imejlova danas",
      "emailsWeek": "Imejlova narednih 7 dana",
      "waiting": "Čeka se klijent",
      "overdue": "Zadaci u kašnjenju",
      "watch": "Nalozi za praćenje"
    },
    "goingOut": {
      "title": "Izlazi",
      "calendar": "Kalendar →",
      "today": "Danas",
      "tomorrow": "Sutra",
      "nothingPlanned": "ništa nije planirano",
      "notScheduled": "{{open}} od {{total}} još nije zakazano",
      "scheduled": "{{count}} zakazano"
    },
    "internal": "Interno",
    "moreCount": "+{{count}} više",
    "pods": {
      "title": "Podovi",
      "structure": "Struktura →",
      "pod": "Pod",
      "clients": "Klijenti",
      "open": "Otvoreno",
      "overdue": "Kasni",
      "waiting": "Na čekanju"
    },
    "myWork": {
      "title": "Moj posao",
      "all": "Sve →",
      "noPersonBefore": "Tvoj nalog još nije povezan sa članom tima — dodaj sebe na stranici",
      "team": "Tim",
      "noPersonAfter": "sa istom imejl adresom.",
      "empty": "Ništa nije otvoreno. Uživaj.",
      "onYou": "Čeka tebe",
      "elsewhere": "U tuđim rukama"
    },
    "watch": {
      "title": "Nalozi za praćenje",
      "healthy": "Svi nalozi izgledaju zdravo.",
      "offboarding": "Odlazak",
      "health": "Zdravlje {{value}}/5",
      "nothingSending": "Ništa se ne šalje narednih 14 dana"
    },
    "out": {
      "title": "Odsutni danas",
      "everyoneIn": "Svi su tu.",
      "until": "do {{date}}",
      "days_one": "{{count}} dan",
      "days_few": "{{count}} dana",
      "days_other": "{{count}} dana"
    },
    "onboarding": {
      "title": "Uvođenje",
      "hr": "HR →"
    }
  },
  "hub": {
    "topics": "Teme",
    "resultsFor": "{{n}} rezultata za „{{query}}“",
    "clear": "Obriši",
    "groupText": {
      "onboarding": "Prvi dani: ko smo, alati i kanali.",
      "policies": "Odmori, bolovanje, sync hours i pravila za Q4.",
      "money": "Fakture, bonusi i preporuke.",
      "work": "Kako je tim organizovan, Slack i naši sastanci.",
      "events": "Okupljanja tima."
    },
    "title": "Hub za zaposlene",
    "empty": "Priručnik još nije uvezen.",
    "search": "Pretraži hub…",
    "home": "Početna",
    "welcome": "Sve o radu u OKTOBER-u",
    "intro": "Odmori, plaćanje, kako radimo zajedno i kako da počneš, na jednom mestu.",
    "synced": "Preuzeto iz ClickUp-a {{date}}",
    "openClickUp": "Otvori u ClickUp-u",
    "startHere": "Počni ovde",
    "startHereName": "Počni ovde, {{name}}",
    "glance": "Ukratko",
    "updated": "Ažurirano {{date}}",
    "readTime": "{{n}} min čitanja",
    "onThisPage": "Na ovoj stranici",
    "previous": "Prethodno",
    "next": "Sledeće",
    "noResults": "Ništa u hubu ne odgovara „{{query}}“",
    "group": {
      "onboarding": "Onboarding",
      "policies": "Odmori i pravila",
      "money": "Plaćanje i fakture",
      "work": "Kako radimo",
      "events": "Događaji"
    }
  },
  "hr": {
    "eyebrow": "Upravljanje ljudima",
    "title": "HR",
    "tab": {
      "hub": "Hub za zaposlene",
      "leave": "Odsustva",
      "org": "Organizaciona šema",
      "onboarding": "Uvođenje"
    },
    "leave": {
      "teamMember": "— član tima —",
      "from": "Od",
      "to": "Do",
      "request": "Zatraži",
      "empty": "Ove godine nema zahteva.",
      "days_one": "{{count}} dan",
      "days_few": "{{count}} dana",
      "days_other": "{{count}} dana",
      "approve": "Odobri",
      "reject": "Odbij",
      "balance": "Stanje godišnjeg odmora",
      "left": "{{remaining}}/{{allowance}} preostalo",
      "allowanceNote": "Podrazumevano 20 dana godišnje — ličnu kvotu možete promeniti na profilu osobe."
    },
    "org": {
      "teams": "Timovi",
      "pods": "Podovi",
      "people": "Ljudi",
      "clients": "Klijenti",
      "teamMeta": "{{pods}} poda · {{people}} ljudi · {{clients}} klijenata",
      "teamLead": "Team lead",
      "designLead": "Design lead",
      "podLead": "Pod lead",
      "retention": "Retention",
      "design": "Dizajn",
      "others": "Ostali",
      "emptyPod": "Još niko drugi nije u ovom podu",
      "shared": "Za ceo tim",
      "noPod": "Još nisu u podu",
      "techs": "Klaviyo tehničari",
      "techsHint": "Timovi iz taskova koje implementiraju",
      "floating": "Van timova",
      "floatingHint": "Floating dizajneri, rukovodstvo i operativa",
      "empty": "Još nema članova tima.",
      "note": "Hijerarhija potiče iz polja \"Menadžer / mentor\" na profilu svake osobe."
    },
    "onb": {
      "templates": "Šabloni",
      "new": "Novi",
      "namePlaceholder": "Naziv šablona (npr. Novi dizajner)",
      "forEmployees": "Za članove tima",
      "forClients": "Za klijente",
      "itemsPlaceholder": "Jedna stavka po redu:\nUgovor potpisan\nLaptop predat\nNalozi kreirani",
      "save": "Sačuvaj",
      "cancel": "Otkaži",
      "edit": "Izmeni",
      "items_one": "{{count}} stavka",
      "items_few": "{{count}} stavke",
      "items_other": "{{count}} stavki",
      "runs_one": "{{count}} pokretanje",
      "runs_few": "{{count}} pokretanja",
      "runs_other": "{{count}} pokretanja",
      "pickEmployee": "— član tima —",
      "pickClient": "— klijent —",
      "start": "Pokreni",
      "active": "Aktivna uvođenja",
      "empty": "Nema uvođenja u toku."
    }
  },
  "clients": {
    "assetUnavailable": "Fajl nije dostupan dok se ne poveže skladište",
    "cancel": "Otkaži",
    "create": "Kreiraj",
    "eyebrow": "Repozitorijum",
    "title": "Klijenti",
    "newClient": "Novi klijent",
    "searchPlaceholder": "Pretraži klijente…  ( / )",
    "namePlaceholder": "Naziv klijenta (npr. Maison Hatch)",
    "empty": {
      "title": "Još nema klijenata",
      "body": "Kreirajte klijenta da biste na jednom mestu čuvali njegov logotip, smernice brenda, fontove i slike."
    },
    "noMatch": "Nijedan klijent ne odgovara pretrazi „{{query}}“.",
    "count_one": "{{count}} klijent",
    "count_few": "{{count}} klijenta",
    "count_other": "{{count}} klijenata",
    "colorsCount_one": "{{count}} boja",
    "colorsCount_few": "{{count}} boje",
    "colorsCount_other": "{{count}} boja",
    "fontsCount_one": "{{count}} font",
    "fontsCount_few": "{{count}} fonta",
    "fontsCount_other": "{{count}} fontova",
    "imagesCount_one": "{{count}} slika",
    "imagesCount_few": "{{count}} slike",
    "imagesCount_other": "{{count}} slika",
    "scaleLabel": "{{n}} od {{max}}",
    "tabs": {
      "overview": "Pregled",
      "pipeline": "Kampanje",
      "calendar": "Kalendar",
      "team": "Tim",
      "onboarding": "Uvođenje",
      "brand": "Brend kit"
    },
    "detail": {
      "allClients": "← Svi klijenti",
      "notFound": "Klijent nije pronađen.",
      "podLead": "Vođa poda: {{name}}",
      "noPod": "{{team}} · bez poda",
      "noTeam": "Nije raspoređen u tim",
      "health": "Zdravlje",
      "nps": "NPS",
      "clientSince": "Klijent od {{date}}",
      "newTask": "Novi zadatak",
      "moreActions": "Više radnji",
      "rename": "Preimenuj klijenta",
      "renamePrompt": "Naziv klijenta",
      "openClickUp": "Otvori u ClickUp-u",
      "delete": "Obriši klijenta",
      "deleteConfirm": "Obrisati klijenta „{{name}}“? Njegovi zadaci ostaju, ali ostaju bez klijenta."
    },
    "overview": {
      "openTasks": "Otvoreni zadaci",
      "waitingOnClient": "Čeka se klijent",
      "overdue": "Kasni",
      "emailsNext7": "Imejlovi narednih 7 dana",
      "emailsSent30": "Poslati imejlovi, 30 dana",
      "needsAttention": "Zahteva pažnju",
      "allClear": "Sve je u redu — ništa nije blokirano, kasni ili čeka.",
      "goingOut": "Izlazi — narednih 14 dana",
      "nothingScheduled": "Ništa nije zakazano za slanje u naredne dve nedelje.",
      "pipeline": "Kampanje",
      "people": "Ljudi na ovom klijentu",
      "noOneAssigned": "Još niko nije dodeljen.",
      "podLead": "Vođa poda",
      "podMember": "Pod",
      "assigned": "Dodeljen",
      "recentActivity": "Skorašnja aktivnost",
      "noActivity": "Još nema promena u October OS-u.",
      "system": "Sistem",
      "onTask": "na",
      "reason": {
        "blocked": "Blokirano",
        "overdue": "Kasni",
        "waiting": "Čeka se klijent",
        "atRisk": "U riziku",
        "noDate": "Bez datuma slanja"
      },
      "noSendDate": "bez datuma slanja",
      "hasIt": "{{name}} ga ima",
      "allScheduled": "sve zakazano",
      "notScheduled_one": "{{count}} još nije zakazan",
      "notScheduled_few": "{{count}} još nisu zakazana",
      "notScheduled_other": "{{count}} još nije zakazano",
      "noOpenTasks": "Nema otvorenih zadataka.",
      "openPipeline": "Otvori kampanje",
      "emailsPerWeek": "Imejlova nedeljno",
      "sent": "poslato",
      "planned": "planirano",
      "weekTitle_one": "Nedelja od {{date}}: {{count}} imejl",
      "weekTitle_few": "Nedelja od {{date}}: {{count}} imejla",
      "weekTitle_other": "Nedelja od {{date}}: {{count}} imejlova",
      "account": "Nalog",
      "status": "Status",
      "pod": "Pod",
      "none": "— nijedan —",
      "health": "Zdravlje",
      "clientSince": "Klijent od",
      "contractEnd": "Kraj ugovora",
      "scope": "Obim",
      "notes": "Beleške",
      "scopePlaceholder": "Šta radimo za njih (npr. 12 kampanja mesečno + flows)",
      "notesPlaceholder": "Sve što tim treba da zna o ovom klijentu…"
    },
    "team": {
      "podTitle": "{{team}} · Pod {{pod}}",
      "pod": "Pod",
      "structure": "Struktura",
      "noPod": "Još nije u podu — izaberite pod u odeljku Nalog na kartici Pregled.",
      "alsoAssigned": "Takođe dodeljeni",
      "nobodyOutside": "Niko van poda.",
      "remove": "Ukloni",
      "assignAria": "Dodeli nekoga ovom klijentu",
      "assignPlaceholder": "+ Dodeli nekoga…",
      "workedOnRecent": "Radili na skorašnjim zadacima",
      "roleOn": "{{role}} na {{n}}",
      "lead": "Vođa",
      "noTasks": "Nema zadataka u poslednjih 8 nedelja"
    }
  },
  "brandKit": {
    "notFound": "Klijent nije pronađen.",
    "tabs": {
      "colors": "Boje",
      "typography": "Tipografija",
      "style": "Stil",
      "figma": "Figma",
      "assets": "Resursi",
      "brand": "Brend dokument"
    },
    "readBy": "Čita ga Figma Email Designer plagin.",
    "saved": "Sačuvano",
    "saving": "Čuvanje…",
    "save": "Sačuvaj brend kit",
    "remove": "Ukloni",
    "copy": "Kliknite da kopirate",
    "colors": {
      "add": "Dodaj boju",
      "addHint": "HEX sa opcionim nazivom i ulogom",
      "namePlaceholder": "Naziv (npr. Zalazak)",
      "addButton": "Dodaj boju",
      "other": "Ostalo",
      "empty": "Još nema boja — dodajte jednu iznad. Tokeni se čuvaju pri sledećem „Sačuvaj izmene“.",
      "token": "Token",
      "contrastWhite": "Kontrast {{ratio}} na belom",
      "contrastBlack": "Kontrast {{ratio}} na crnom"
    },
    "roles": {
      "primary": "Primarna",
      "secondary": "Sekundarna",
      "accent": "Akcenat",
      "neutral": "Neutralna",
      "semantic": "Semantička"
    },
    "typography": {
      "scale": "Tipografska skala",
      "scaleHint": "Veličine (px) koje plagin koristi za naslove, tekst i dugmad. Imejl se renderuje u širini od 1200 px.",
      "body": "Tekst",
      "bodySmall": "Mali tekst",
      "button": "Dugme",
      "specimens": "Uzorci fontova",
      "specimensEmpty": "Otpremite .otf / .ttf / .woff / .woff2 — učitaće se preko @font-face.",
      "specimensLoaded_one": "{{count}} font učitan preko @font-face",
      "specimensLoaded_few": "{{count}} fonta učitana preko @font-face",
      "specimensLoaded_other": "{{count}} fontova učitano preko @font-face",
      "uploadFont": "Otpremi font",
      "dragHint": "Prevlačenje fajlova je na kartici Resursi. Fajlovi se ovde prikazuju kao uzorci.",
      "noFonts": "Još nema otpremljenih fontova.",
      "pairings": "Kombinacije",
      "pairingsHint": "Kombinacije naslova i teksta koje se preporučuju u imejlovima",
      "addPairing": "Dodaj kombinaciju",
      "pairingName": "Kombinacija {{n}}",
      "removeFont": "Ukloni font",
      "sampleHeading": "Aa Bb Cc",
      "pangram": "Ljubazni fenjerdžija čađavog lica hoće da mi pokaže štos. 0123456789",
      "heading": "Naslov",
      "sampleTitle": "Nova sezona, novi oblici.",
      "sampleBody": "Kratak pasus u fontu za tekst. Namenjen tekstu u vašim imejlovima — čist, čitljiv na malim ekranima i usklađen sa glasom vašeg brenda."
    },
    "style": {
      "radii": "Radijusi",
      "radiiHint": "Skala radijusa uglova. Plagin ih čita pri pravljenju frejmova od nule.",
      "small": "Mali (sm)",
      "smallHint": "polja / čipovi",
      "card": "Kartica",
      "cardHint": "kartice proizvoda",
      "section": "Sekcija",
      "sectionHint": "veliki zaobljeni blokovi",
      "pill": "Pilula",
      "pillHint": "dugmad u obliku pilule",
      "shadows": "Senke",
      "shadowsHint": "Recepti u CSS stilu — kopirajte ih doslovno iz svojih tokena.",
      "elevated": "Podignuta",
      "buttonSpec": "Specifikacija dugmeta",
      "buttonSpecHint": "Kako se CTA prikazuju od nule: razmak, font, transformacija, radijus.",
      "fontFamily": "Porodica fontova",
      "fontFamilyHint": "Ostavite prazno da se koristi font teksta",
      "fontFamilyPlaceholder": "npr. Apercu Pro",
      "paddingY": "Razmak Y",
      "paddingX": "Razmak X",
      "fontSize": "Veličina fonta",
      "fontWeight": "Debljina fonta",
      "weight400": "Regularan (400)",
      "weight500": "Srednji (500)",
      "weight700": "Podebljan (700)",
      "transform": "Transformacija",
      "uppercase": "VELIKA SLOVA",
      "normal": "Normalno",
      "letterSpacing": "Razmak slova (em)",
      "radius": "Radijus",
      "cardRadius": "Radijus kartice",
      "smallRadius": "Mali radijus",
      "cardSpec": "Specifikacija kartice",
      "cardSpecHint": "Kako se kartice proizvoda / sadržaja prikazuju od nule.",
      "gap": "Razmak",
      "surface": "Površina",
      "surfacePlaceholder": "#FFFFFF ili naziv tokena",
      "shadow": "Senka",
      "cardRecipe": "Recept kartice",
      "elevatedRecipe": "Recept podignute senke",
      "none": "Nema"
    },
    "figma": {
      "header": "Zaglavlje",
      "headerHint": "Logotip + navigacija. Dodaje se na početak svakog imejla — za njega se ne generiše AI tekst.",
      "hero": "Hero",
      "heroHint": "Naslov + podnaslov + glavni CTA",
      "body": "Telo",
      "bodyHint": "Pasusi, sekundarni naslovi, razdelnici, CTA u telu",
      "product": "Proizvod",
      "productHint": "Mreže kartica — slika + naziv + cena + CTA",
      "footer": "Podnožje",
      "footerHint": "Linkovi, adresa, odjava, ikone društvenih mreža",
      "mapping": "Mapiranje Figma komponenti",
      "mappingHint": "Kada plagin pravi imejl za ovog klijenta, instancira ove komponente po nazivu (traže se u trenutnom Figma fajlu). Ostavite prazno da se koristi generički pravljenje frejmova.",
      "placeholder": "npr. EmailHero/Default",
      "slots": "Konvencija slotova",
      "slotsHint": "Unutar vaših registrovanih komponenti nazovite tekstualne slojeve kao ispod da bi primili generisani tekst.",
      "layerNames": "Nazivi slojeva prihvataju bilo koji od",
      "or": "ili"
    },
    "assets": {
      "logo": "Logotip",
      "logoHint": "Poželjan je SVG; PNG takođe radi",
      "replace": "Zameni",
      "dropLogo": "Spustite logotip ovde ili kliknite da izaberete",
      "fonts": "Fontovi",
      "images": "Slike",
      "dropFonts": "Spustite fontove ovde ili kliknite da izaberete",
      "dropImages": "Spustite slike ovde ili kliknite da izaberete",
      "fileCount_one": "{{count}} fajl",
      "fileCount_few": "{{count}} fajla",
      "fileCount_other": "{{count}} fajlova",
      "removeConfirm": "Ukloniti „{{name}}“?"
    },
    "doc": {
      "title": "Smernice brenda",
      "hint": "Markdown — glas, paleta, tipografija, ograničenja. Čita ga /generate."
    }
  },
  "team": {
    "details": {
      "profile": "Profil",
      "email": "Email",
      "emailHint": "Koristi se za Google prijavu",
      "roleTeam": "Rola i tim",
      "role": "Rola",
      "level": "Nivo",
      "noPod": "Bez poda",
      "employment": "Zaposlenje",
      "login": "Prijava",
      "loginLinked": "Prijavljivao se",
      "loginNone": "Još se nije prijavio",
      "deleteHint": "Uklanja osobu sa zadataka, iz podova i org šeme."
    },
    "tabDetails": "Detalji",
    "profile": {
      "onDesk": "Na stolu",
      "upcoming": "Uskoro",
      "clients": "Klijenti",
      "daysLeft": "Preostalo dana odmora",
      "desk": "Na stolu",
      "allTasks": "Svi zadaci →",
      "deskEmpty": "Trenutno ništa nije na stolu.",
      "worksOn": "Radi na",
      "noClients": "Trenutno bez klijenata.",
      "place": "U timu",
      "team": "Tim",
      "noTeam": "Nije u timu",
      "pod": "Pod",
      "reportsTo": "Odgovara",
      "reports": "Direktno mu odgovaraju",
      "timeOff": "Odsustva",
      "hr": "Odsustva →",
      "leftOf": "Još {{left}} od {{total}} dana ove godine",
      "noLeave": "Nema planiranih odsustava.",
      "pending": "Na čekanju",
      "assigned": "Dodeljeni klijenti",
      "unassign": "Ukloni",
      "noneAssigned": "Nijedan — pod i zadaci pokazuju gde radi.",
      "assign": "Dodeli klijenta…"
    },
    "eyebrow": "Ljudi",
    "eyebrowCount": "Ljudi · {{count}}",
    "title": "Tim",
    "searchPlaceholder": "Pretraži tim…",
    "newEmployee": "Novi zaposleni",
    "fullName": "Ime i prezime",
    "emailPlaceholder": "ime@oktoberagency.com",
    "add": "Dodaj",
    "cancel": "Otkaži",
    "emptyTitle": "Još nema zaposlenih",
    "emptyHint": "Dodaj prvog člana tima — njegov imejl ga povezuje sa Google prijavom.",
    "clientCount_one": "{{count}} klijent",
    "clientCount_few": "{{count}} klijenta",
    "clientCount_other": "{{count}} klijenata",
    "noLogin": "još nema prijavu",
    "notFound": "Osoba nije pronađena.",
    "saved": "Sačuvano ✓",
    "saving": "Čuvanje…",
    "deleteConfirm": "Ukloniti {{name}} iz tima?",
    "tabOverview": "Pregled",
    "tabClients_one": "Klijenti ({{count}})",
    "tabClients_few": "Klijenti ({{count}})",
    "tabClients_other": "Klijenti ({{count}})",
    "tabTasks": "Zadaci",
    "basics": "Osnovno",
    "emailLabel": "Imejl (koristi se za Google prijavu)",
    "jobTitle": "Zvanje",
    "teamLabel": "Tim",
    "phone": "Telefon",
    "statusStructure": "Status i struktura",
    "status": "Status",
    "startDate": "Datum početka",
    "manager": "Nadređeni / mentor (organigram)",
    "managerNone": "— nema —",
    "directReports": "Direktno podređeni:",
    "loginLabel": "Prijava:",
    "loginLinked": "povezana ✓",
    "loginNone": "još se nije prijavio",
    "notes": "Beleške",
    "notesPlaceholder": "Interne beleške o ovoj osobi…",
    "deleteEmployee": "Ukloni zaposlenog",
    "worksOn": "Klijenti na kojima radi {{name}}",
    "noClients": "Još nema klijenata.",
    "open": "Otvori",
    "assigned": "Dodeljen ✓",
    "assign": "Dodeli"
  },
  "structure": {
      "eyebrow": "Timovi · podovi · klijenti",
      "title": "Struktura",
      "unpodded_one": "{{count}} klijent još nije u podu:",
      "unpodded_few": "{{count}} klijenta još nisu u podu:",
      "unpodded_other": "{{count}} klijenata još nije u podu:",
      "ledBy": "vodi {{name}}",
      "pod": "Pod {{name}}",
      "clientsCount_one": "{{count}} klijent",
      "clientsCount_few": "{{count}} klijenta",
      "clientsCount_other": "{{count}} klijenata",
      "openTasksCount_one": "{{count}} otvoren zadatak",
      "openTasksCount_few": "{{count}} otvorena zadatka",
      "openTasksCount_other": "{{count}} otvorenih zadataka",
      "noLead": "Nema RM3 lidera",
      "floating": "Među timovima / nije raspoređeno",
      "unplaced": "Klijenti bez tima",
      "mentor": "mentor: {{name}}",
      "start": "početak {{date}}",
      "new": "novo",
      "health": "zdravlje {{value}}/5"
  },
  "picker": {
    "search": "Pretraga…",
    "noMatch": "Nema rezultata",
    "pickDate": "Izaberi datum",
    "prevMonth": "Prethodni mesec",
    "nextMonth": "Sledeći mesec",
    "today": "Danas",
    "clear": "Obriši",
    "done": "Gotovo",
    "hours": "Sati",
    "minutes": "Minuti"
  },
  "ai": {
    "answeringAs": "Odgovara kao {{name}}",
    "chip": {
      "findCampaigns_one": "Pregledana je {{count}} kampanja",
      "findCampaigns_few": "Pregledane su {{count}} kampanje",
      "findCampaigns_other": "Pregledano je {{count}} kampanja",
      "findCampaignsRunning": "Pregledam kampanje…",
      "getCampaign": "Otvorena je kampanja",
      "getCampaignRunning": "Otvaram kampanju…",
      "getCampaignCopy": "Pročitan je tekst kampanje",
      "getCampaignCopyRunning": "Čitam tekst kampanje…",
      "findClients_one": "Pregledan je {{count}} klijent",
      "findClients_few": "Pregledana su {{count}} klijenta",
      "findClients_other": "Pregledano je {{count}} klijenata",
      "findClientsRunning": "Pregledam klijente…",
      "getClient": "Otvoren je klijent",
      "getClientRunning": "Otvaram klijenta…",
      "findPeople_one": "Pregledana je {{count}} osoba",
      "findPeople_few": "Pregledane su {{count}} osobe",
      "findPeople_other": "Pregledano je {{count}} osoba",
      "findPeopleRunning": "Pregledam osobe…",
      "getPerson": "Otvoren je profil",
      "getPersonRunning": "Otvaram profil…",
      "getStructure": "Pregledana je struktura",
      "getStructureRunning": "Pregledam strukturu…",
      "getTimeOff_one": "Pregledan je {{count}} zahtev za odsustvo",
      "getTimeOff_few": "Pregledana su {{count}} zahteva za odsustvo",
      "getTimeOff_other": "Pregledano je {{count}} zahteva za odsustvo",
      "getTimeOffRunning": "Pregledam odsustva…",
      "getHandbook": "Pročitan je priručnik",
      "getHandbookRunning": "Čitam priručnik…",
      "createCampaigns_one": "Kreirana je {{count}} kampanja",
      "createCampaigns_few": "Kreirane su {{count}} kampanje",
      "createCampaigns_other": "Kreirano je {{count}} kampanja",
      "createCampaignsRunning": "Kreiram kampanje…",
      "updateCampaigns_one": "Ažurirana je {{count}} kampanja",
      "updateCampaigns_few": "Ažurirane su {{count}} kampanje",
      "updateCampaigns_other": "Ažurirano je {{count}} kampanja",
      "updateCampaignsRunning": "Ažuriram kampanje…",
      "shiftCampaignDates_one": "Pomereni su datumi za {{count}} kampanju",
      "shiftCampaignDates_few": "Pomereni su datumi za {{count}} kampanje",
      "shiftCampaignDates_other": "Pomereni su datumi za {{count}} kampanja",
      "shiftCampaignDatesRunning": "Pomeram datume kampanja…",
      "deleteCampaigns_one": "Obrisana je {{count}} kampanja",
      "deleteCampaigns_few": "Obrisane su {{count}} kampanje",
      "deleteCampaigns_other": "Obrisano je {{count}} kampanja",
      "deleteCampaignsRunning": "Brišem kampanje…",
      "commentOnCampaigns_one": "Dodat je komentar na {{count}} kampanju",
      "commentOnCampaigns_few": "Dodat je komentar na {{count}} kampanje",
      "commentOnCampaigns_other": "Dodat je komentar na {{count}} kampanja",
      "commentOnCampaignsRunning": "Dodajem komentar…",
      "updateClient": "Ažuriran je klijent {{name}}",
      "updateClientRunning": "Ažuriram klijenta…",
      "setClientTeamMember": "Promenjen je tim klijenta",
      "setClientTeamMemberRunning": "Menjam tim klijenta…",
      "requestTimeOff": "Zatraženo je odsustvo",
      "requestTimeOffRunning": "Tražim odsustvo…",
      "decideTimeOff": "Doneta je odluka o zahtevu za odsustvo",
      "decideTimeOffRunning": "Odlučujem o zahtevu za odsustvo…",
      "updatePersonPlacement": "Promenjeno je mesto osobe u strukturi",
      "updatePersonPlacementRunning": "Menjam mesto osobe u strukturi…",
      "setLead": "Promenjen je lider",
      "setLeadRunning": "Menjam lidera…",
      "other": "{{tool}}: završeno",
      "otherRunning": "{{tool}}: u toku…",
      "failed": "Nije uspelo: {{tool}}",
      "tool": {
        "findCampaigns": "Pretraga kampanja",
        "getCampaign": "Otvaranje kampanje",
        "getCampaignCopy": "Čitanje teksta kampanje",
        "findClients": "Pretraga klijenata",
        "getClient": "Otvaranje klijenta",
        "findPeople": "Pretraga osoba",
        "getPerson": "Otvaranje profila",
        "getStructure": "Pregled strukture",
        "getTimeOff": "Pregled odsustava",
        "getHandbook": "Čitanje priručnika",
        "createCampaigns": "Kreiranje kampanja",
        "updateCampaigns": "Izmena kampanja",
        "shiftCampaignDates": "Pomeranje datuma kampanja",
        "deleteCampaigns": "Brisanje kampanja",
        "commentOnCampaigns": "Komentarisanje kampanja",
        "updateClient": "Izmena klijenta",
        "setClientTeamMember": "Promena tima klijenta",
        "requestTimeOff": "Zahtev za odsustvo",
        "decideTimeOff": "Odluka o zahtevu za odsustvo",
        "updatePersonPlacement": "Promena mesta osobe u strukturi",
        "setLead": "Promena lidera"
      }
    },
    "ask": "Pitaj Okta",
    "chats": "Razgovori",
    "newChat": "Novi razgovor",
    "openInChats": "Otvori u razgovorima",
    "close": "Zatvori",
    "noChats": "Još nema razgovora",
    "allChats": "Svi razgovori",
    "untitled": "Razgovor bez naslova",
    "chatActions": "Radnje za razgovor",
    "chatTitle": "Naslov razgovora",
    "rename": "Preimenuj",
    "delete": "Obriši",
    "group": {
      "today": "Danas",
      "yesterday": "Juče",
      "lastWeek": "Prošle nedelje",
      "older": "Ranije"
    },
    "placeholder": "Pitaj Okta bilo šta…",
    "send": "Pošalji",
    "loading": "Učitavanje…",
    "thinking": "Okto razmišlja…",
    "steps_one": "{{count}} korak",
    "steps_few": "{{count}} koraka",
    "steps_other": "{{count}} koraka",
    "reset": "Probni podaci su vraćeni na početak posle ovog razgovora. Izmene iznad više ne postoje.",
    "refused": "Okto nije mogao da pomogne s tim.",
    "error": "Nešto nije u redu.",
    "retry": "Pokušaj ponovo",
    "busy": "Ovaj razgovor je zauzet u drugom prozoru. Pokušaj ponovo za trenutak.",
    "stoppedAfterRounds": "Zaustavljeno posle {{rounds}} krugova provera. Pošalji poruku da nastaviš.",
    "cancelled": "{{tool}}: otkazano",
    "cancelledByReload": "{{tool}}: otkazano ponovnim učitavanjem",
    "notRun": "{{tool}}: nije pokrenuto",
    "empty": {
      "title": "Ćao, ja sam Okto",
      "hint": "Pitaj me o klijentima, ljudima, kampanjama i odsustvima, ili traži izmenu. Pitaću te pre svake veće izmene."
    },
    "confirm": {
      "yes": "Uradi",
      "no": "Otkaži",
      "more": "i još {{count}}",
      "delete_one": "Ovo trajno briše {{count}} kampanju.",
      "delete_few": "Ovo trajno briše {{count}} kampanje.",
      "delete_other": "Ovo trajno briše {{count}} kampanja.",
      "people_one": "Ovo menja ko radi na {{count}} kampanji.",
      "people_few": "Ovo menja ko radi na {{count}} kampanje.",
      "people_other": "Ovo menja ko radi na {{count}} kampanja.",
      "clientAdd": "Ovo dodaje nekoga u tim klijenta.",
      "clientRemove": "Ovo uklanja nekoga iz tima klijenta.",
      "clientPod": "Ovo premešta klijenta u drugi pod, pa se menja ceo njegov tim.",
      "placement": "Ovo premešta nekoga u strukturi tima.",
      "lead": "Ovo menja ko vodi tim ili pod.",
      "approve": "Ovo odobrava zahtev za odsustvo.",
      "reject": "Ovo odbija zahtev za odsustvo.",
      "bulk_one": "Ovo menja {{count}} zapis.",
      "bulk_few": "Ovo menja {{count}} zapisa.",
      "bulk_other": "Ovo menja {{count}} zapisa.",
      "alreadyDone_one": "{{count}} je već izmenjen.",
      "alreadyDone_few": "{{count}} su već izmenjena.",
      "alreadyDone_other": "{{count}} je već izmenjeno."
    },
    "model": {
      "label": "Model",
      "note": {
        "opus": "Jak za sve",
        "sonnet": "Brži, upola jeftiniji",
        "haiku": "Najbrži i najjeftiniji, za jednostavne provere"
      }
    },
    "admin": {
      "title": "Admin razgovori",
      "model": {
        "label": "Model za sve",
        "pick": "Model za sve: {{model}}",
        "changed": "Svi sada koriste {{model}}",
        "changedBy": "Promenio/la {{name}} · {{when}}",
        "neverChanged": "Podrazumevani, nije menjan"
      },
      "unknownUser": "Nepoznat korisnik",
      "readOnly": "Samo za čitanje",
      "deletedAccount": "(obrisan nalog)",
      "loadFailed": "Razgovori nisu učitani.",
      "openFailed": "Razgovor nije učitan.",
      "gone": "Ovaj razgovor više ne postoji.",
      "back": "Svi razgovori",
      "search": "Pretraži pitanje ili nalog",
      "deleted": "obrisan",
      "deletedByOwner": "Obrisao vlasnik",
      "slowHint": "Poziv je trajao 30 s ili duže",
      "total": {
        "spend": "Potrošnja",
        "conversations": "Razgovori",
        "tokens": "Tokeni: ulaz / keširano / izlaz"
      },
      "col": {
        "when": "Kada",
        "account": "Nalog",
        "question": "Pitanje",
        "turns": "Razmene",
        "cost": "Trošak",
        "model": "Model",
        "time": "Vreme",
        "status": "Status"
      },
      "tokens": {
        "in": "Ulaz",
        "cached": "Keširano",
        "out": "Izlaz"
      },
      "status": {
        "ok": "OK",
        "failed": "Neuspelo",
        "refused": "Odbijeno",
        "stopped": "Prekinuto"
      },
      "filter": {
        "account": "Nalog",
        "allAccounts": "Svi nalozi",
        "from": "Od",
        "to": "Do",
        "tool": "Alat",
        "allTools": "Svi alati",
        "all": "Sve",
        "failed": "Neuspeli",
        "slow": "Spori"
      }
    }
  }
}
